<template>
    <div>
        <HeaderSection icon="fas fa-calendar-alt" title="Configuración de periodos">
            <template slot="buttons">
                <el-button
                        size="medium"
                        type="danger"
                        icon="el-icon-arrow-left"
                        @click="$router.push('/administracion')">
                    Regresar
                </el-button>
            </template>
        </HeaderSection>

        <el-form ref="configForm" :model="configForm">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item
                            label="Fecha Inicio"
                            prop="dateStart"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-date-picker
                                :picker-options="{
                                                    disabledDate(time) {
                                                        if( time > Date.now() ) {
                                                            return true
                                                        } else {
                                                            return false
                                                        }
                                                    }
                                                 }"
                                type="date"
                                style="width: 100%"
                                :disabled="!editDates"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Fecha Registro"
                                v-model="configForm.dateStart">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item
                            label="Fecha Final"
                            prop="dateEnd"
                            :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change'}">
                        <el-date-picker
                                :picker-options="{
												disabledDate(time) {
													if( time.getTime() < new Date(configForm.dateStart).getTime() ||
													    time < Date.now() ) {
														return true
													}
												}
											}"
                                type="date"
                                style="width: 100%"
                                :disabled="!editDates"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Fecha Registro"
                                v-model="configForm.dateEnd">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8" style="margin-top: 45px;">
                    <el-button
                            size="medium"
                            v-if="!editDates"
                            type="primary"
                            icon="fas fa-calendar-alt"
                            @click="editDates=true">
                        Modificar Fechas
                    </el-button>
                    <el-button
                            v-if="editDates"
                            size="medium"
                            type="danger"
                            icon="el-icon-arrow-left"
                            @click="editDates=false">
                        Cancelar
                    </el-button>
                    <el-button
                            v-if="editDates"
                            size="medium"
                            type="success"
                            icon="fas fa-save"
                            @click="submitForm('configForm')">
                        Guardar Fechas
                    </el-button>
                </el-col>


            </el-row>
        </el-form>
        <br>

    </div>
</template>


<script>
    import HeaderSection from '../../../partials/HeaderSection';

    export default {

        components: {
            HeaderSection,

        },

        data() {
            return {
                configForm: {
                    dateStart: null,
                    dateEnd: null,
                    isActive: '',
                },
                isActive: false,
                editDates: false,
                pickerOptionsOne: {
                    disabledDate(time) {
                        let yesterday = moment().subtract(1, 'day');
                        return time.getTime() < yesterday;
                    }
                }


            }
        },
        computed: {
            pickerOptions() {

                let _self = this;
                return {
                    disabledDate(time) {
                        if (!_self.configForm) {
                            return true;
                        }
                        let day = moment(_self.configForm.dateStart);
                        let yesterday = moment().subtract(1, 'day');
                        return time.getTime() < day;// || time.getTime() < yesterday;
                    }
                }
            }

        },

        created() {

            let _this = this;

            this.$store.dispatch(
                'loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});

            axios.get('/api/configurationDates').then(response => {
                this.configForm = response.data.ConfigurationDates;

                this.$store.dispatch('loading/spinner', {}, {root: true});

            }).catch(error => {

                this.$notify.error({
                    title: 'Error',
                    message: 'Ocurrió un error inesperado al mostrar las fechas'
                });

            });

        },

        methods: {

            submitForm(formName) {

                let _this = this;

                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        this.$store.dispatch(
                            'loading/spinner', {msg: 'Cargando Datos...', status: true}, {root: true});

                        let data =
                            {
                                dateStart: this.configForm.dateStart,
                                dateEnd: this.configForm.dateEnd,

                            };
                        axios.put('/api/configurationDates/1', data).then(response => {

                            this.$store.dispatch('loading/spinner', {}, {root: true});
                            if (response.data.success) {
                                this.$notify({
                                    title: 'Éxito',
                                    message: 'Actualización correcta',
                                    type: 'success'
                                });

                                _this.editDates = false;

                                this.$router.push('/administracion/configuracion');
                            } else {
                                this.$store.dispatch('loading/spinner', {}, {root: true});
                                this.$notify({
                                    title: 'Error',
                                    message: 'No fue posible actualizar la infromación de las fechas, trate nuevamente',
                                    type: 'error'
                                });
                            }

                        }).catch(error => {
                            this.$store.dispatch('loading/spinner', {}, {root: true});
                            this.$notify({
                                title: 'Error',
                                message: 'Se interrumpió la conexión con el servidor',
                                type: 'error'
                            });
                        });

                    } else {
                        this.$notify({
                            title: 'Mensaje',
                            message: 'Por favor complete todos los campos requeridos.',
                            type: 'warning'
                        });
                        return false;
                    }
                });

            },

        },

        watch:{
            'configForm.dateStart'(){
                if(this.configForm.dateEnd == null || this.configForm.dateEnd == '') {
                    this.configForm.dateEnd = this.configForm.dateStart;
                }

                if(this.configForm.dateEnd != null &&
                    this.configForm.dateStart > this.configForm.dateEnd){
                    this.configForm.dateEnd = this.configForm.dateStart;
                }

            },
        }

    }
</script>

<style>
</style>